import { useAppStore } from '../store/appStore';

export type UserTier = 'guest' | 'free' | 'premium';
export const GUEST_CARD_LIMIT = 3;

export function useContentAccess() {
  const user = useAppStore((s) => s.user);

  // Existing users before the tier field was added default to 'free'
  const tier: UserTier = (user?.tier as UserTier) ?? (user ? 'free' : 'guest');

  return {
    tier,
    isGuest: tier === 'guest',
    isFree: tier === 'free',
    isPremium: tier === 'premium',

    /** True if the user can see the card at this list index (guest limit: 3) */
    canViewCard: (index: number) => tier !== 'guest' || index < GUEST_CARD_LIMIT,

    /** True if user can access premium-flagged scenarios/bundles */
    canViewPremium: () => tier === 'premium',

    /** True if user can start a Practice session */
    canPractise: () => tier === 'premium',

    /** True if user can post in Community */
    canPostCommunity: () => tier !== 'guest',

    /** True if user can save scenarios for offline use */
    canSaveOffline: () => tier === 'premium',
  };
}
